import type { IconButtonProps } from "@mui/material";
import type { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { CardArchiveButton } from "../../../moment-card/components/card-archive-button";
import type { MomentFormMoment } from "../../types/moment-form-moment";

export const ArchiveButton: FC<IconButtonProps & { reloadMoment: () => void }> = ({
  reloadMoment,
  ...rest
}) => {
  const {
    control,
    getValues,
    formState: { isDirty },
  } = useFormContext<MomentFormMoment>();
  useWatch({
    control,
    name: ["deleted_at", "status", "running", "title"],
  });
  const [deleted_at, status, running, title] = getValues([
    "deleted_at",
    "status",
    "running",
    "title",
  ]);

  const isDeleted = !!deleted_at;
  const isArchived = status === "archived";
  const isActive = status === "active" && running;
  const unsavedChanges = isDirty || title === "";

  const id = getValues("id");

  return (
    <CardArchiveButton
      {...rest}
      id={id}
      isDeleted={isDeleted}
      isArchived={isArchived}
      isActive={isActive}
      unsavedChanges={unsavedChanges && status !== "finished"}
      status={status}
      onClicked={reloadMoment}
    />
  );
};
